export const NPS_ID = 'NPS';
const CSAT_ID = 'CSAT';
const CES_ID = 'CES';
const NES_ID = 'NES';
const CUSTOM_ID = 'custom';
const ASC_ORDER_ID = 'asc';
const DESC_ORDER_ID = 'desc';
const NPS_SCORE_ID = 'SCORE_TYPE_1';
const CES_SCORE_ID = 'SCORE_TYPE_2';
const CSAT_SCORE_ID = 'SCORE_TYPE_3';

const VALUE_RANGE_1_10 = { 'from': 1, 'to': 10 };
const VALUE_RANGE_1_5 = { 'from': 1, 'to': 5 };
const VALUE_RANGE_1_7 = { 'from': 1, 'to': 7 };
const VALUE_RANGE_0_10 = { 'from': 0, 'to': 10 };
const VALUE_RANGE_1_9 = { 'from': 1, 'to': 9 };
const VALUE_RANGE_0_1 = { 'from': 0, 'to': 1 };

export const NPS_SURVEY_PARAMS = newMeasurementParams(NPS_ID, VALUE_RANGE_1_10, DESC_ORDER_ID, NPS_SCORE_ID, 1, 6, 9, 10);
const CSAT_SURVEY_PARAMS = newMeasurementParams(CSAT_ID, VALUE_RANGE_1_5, DESC_ORDER_ID, CSAT_SCORE_ID, -1, -1, 4, 5);
const CES_SURVEY_PARAMS = newMeasurementParams(CES_ID, VALUE_RANGE_1_7, DESC_ORDER_ID, CES_SCORE_ID);
const NES_SURVEY_PARAMS = newMeasurementParams(NES_ID, VALUE_RANGE_1_7, ASC_ORDER_ID, NPS_SCORE_ID, 1, 2, 5, 7);
const CUSTOM_SURVEY_PARAMS = newMeasurementParams(CUSTOM_ID, VALUE_RANGE_1_10, DESC_ORDER_ID, NPS_SCORE_ID, 1, 6, 9, 10);


editSurveyFeedbackBoxController.$inject = ['$scope',
                                          '$mdDialog',
                                          '$translate',
                                          'QuickRepliesFactory',
                                          'context',
                                          'elementData',
                                          'siteTypeConfig'];
export function editSurveyFeedbackBoxController($scope,
                                               $mdDialog,
                                               $translate,
                                               QuickRepliesFactory,
                                               context,
                                               elementData,
                                               siteTypeConfig) {

  let keyPrefix = 'parameters/quick_replies/details/graph/measurement_type/';
  const NPS_TYPE = {
    'id': NPS_ID,
    'label': $translate.instant(keyPrefix + NPS_ID) + ' (1->10)',
    'parameters': NPS_SURVEY_PARAMS
  };
  const CSAT_TYPE = {
    'id': CSAT_ID,
    'label': $translate.instant(keyPrefix + CSAT_ID) + ' (1->5)',
    'parameters': CSAT_SURVEY_PARAMS
  };
  const CES_TYPE = {
    'id': CES_ID,
    'label': $translate.instant(keyPrefix + CES_ID) + ' (1->7)',
    'parameters': CES_SURVEY_PARAMS
  };
  const NES_TYPE = {
    'id': NES_ID,
    'label': $translate.instant(keyPrefix + NES_ID) + ' (1->7)',
    'parameters': NES_SURVEY_PARAMS
  };
  const CUSTOM_TYPE = {
    'id': CUSTOM_ID,
    'label': $translate.instant(keyPrefix + CUSTOM_ID),
    'parameters': CUSTOM_SURVEY_PARAMS
  };

  keyPrefix = 'parameters/quick_replies/details/graph/display_order/';
  const ASC_ORDER_TYPE = {
    'id': ASC_ORDER_ID,
    'label': $translate.instant(keyPrefix + ASC_ORDER_ID),
  };
  const DESC_ORDER_TYPE = {
    'id': DESC_ORDER_ID,
    'label': $translate.instant(keyPrefix + DESC_ORDER_ID),
  };

  keyPrefix = 'parameters/quick_replies/details/graph/score/';
  const NPS_SCORE_TYPE = {
    'id': NPS_SCORE_ID,
    'label': $translate.instant(keyPrefix + 'pos_minus_neg'),
  };
  const CES_SCORE_TYPE = {
    'id': CES_SCORE_ID,
    'label': $translate.instant(keyPrefix + 'avg'),
  };
  const CSAT_SCORE_TYPE = {
    'id': CSAT_SCORE_ID,
    'label': $translate.instant(keyPrefix + 'avg_percent'),
  };


  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.feedbackTypeChanged = feedbackTypeChanged;
  $scope.valueRangeChanged = valueRangeChanged;
  $scope.orderTypeChanged = orderTypeChanged;

  init();

  function ok() {
    $scope.elementData.message = $scope.editorModelAccessor.getModelOfFirstMessage();

    // Fetch unique ids for answers that don't have one yet
    const answersWithoutId = $scope.elementData.answers.filter(answer => !answer.id);
    if (answersWithoutId.length > 0) {
      QuickRepliesFactory.createUniqueIds(context.companyId, context.site.id, context.scenarioId, answersWithoutId.length)
        .then(response => {
          const ids = response.data.map(element => element.id);
          let index = 0;
          answersWithoutId.forEach(answer => answer.id = ids[index++]);
          $mdDialog.hide({type: 'ok', data: $scope.elementData});
        });
    } else {
      $mdDialog.hide({type: 'ok', data: $scope.elementData});
    }
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function feedbackTypeChanged() {
    const feedbackType = $scope.feedbackTypes.find(type => type.id === $scope.elementData.feedbackType);
    const newParams = angular.copy(feedbackType.parameters);
    $scope.elementData.name = newParams.name;
    $scope.elementData.valueRange = newParams.valueRange;
    $scope.elementData.order = newParams.order;
    $scope.elementData.score = newParams.score;
    $scope.elementData.negativeAndPositiveRanges = newParams.negativeAndPositiveRanges;

    valueRangeChanged();
    updateAnswers();
    $scope.customValuesDisabled = elementData.feedbackType !== 'custom';
  }

  function valueRangeChanged() {
    const valueRange = $scope.elementData.valueRange;
    $scope.allowedValuesForNegativeTo = rangeInclusive(valueRange.from, valueRange.to-1);
    $scope.allowedValuesForPositiveFrom = rangeInclusive(valueRange.from+1, valueRange.to);
    const negAndPosRanges = $scope.elementData.negativeAndPositiveRanges;
    if (negAndPosRanges) {
      updateAllowedNegativeTo(negAndPosRanges.negative.to);
      updateAllowedPositiveFrom(negAndPosRanges.positive.from);
    }
    updateAnswers();
  }

  function orderTypeChanged() {
    updateAnswers();
  }

  function updateAllowedNegativeToFromPositiveFrom() {
    const negAndPosRanges = $scope.elementData.negativeAndPositiveRanges;
    updateAllowedNegativeTo(negAndPosRanges.positive.from-1);
  }
  function updateAllowedNegativeTo(maxNegativeTo) {
    const negAndPosRanges = $scope.elementData.negativeAndPositiveRanges;
    const valueRange = $scope.elementData.valueRange;
    const maxValue = Math.min(maxNegativeTo, valueRange.to-1);
    if (negAndPosRanges.negative.to > maxValue) {
      negAndPosRanges.negative.to = maxValue;
    }
    if (negAndPosRanges.negative.to < valueRange.from) {
      negAndPosRanges.negative.to = valueRange.from;
    }
    negAndPosRanges.negative.from = valueRange.from;
  }
  function updateAllowedPositiveFromFromNegativeTo() {
    const negAndPosRanges = $scope.elementData.negativeAndPositiveRanges;
    updateAllowedPositiveFrom(negAndPosRanges.negative.to+1);
  }
  function updateAllowedPositiveFrom(minPositiveFrom) {
    const negAndPosRanges = $scope.elementData.negativeAndPositiveRanges;
    const valueRange = $scope.elementData.valueRange;
    const minValue = Math.max(minPositiveFrom, valueRange.from+1);
    if (negAndPosRanges.positive.from < minValue) {
      negAndPosRanges.positive.from = minValue;
    }
    if (negAndPosRanges.positive.from > valueRange.to) {
      negAndPosRanges.positive.from = valueRange.to
    }
    negAndPosRanges.positive.to = valueRange.to;
  }
  $scope.updateAllowedNegativeToFromPositiveFrom = updateAllowedNegativeToFromPositiveFrom;
  $scope.updateAllowedPositiveFromFromNegativeTo = updateAllowedPositiveFromFromNegativeTo;

  /**
   * Adds, removes, and reorders answers so that they match the value range and sort type.
   * Answers are tracked by score in this controller, not by id (missing ids are added upon modal submission)
   */
  function updateAnswers() {
    const valueRange = $scope.elementData.valueRange;
    const newAnswers = [];
    for (let score = valueRange.from; score <= valueRange.to; score++) {
      const existingAnswer = $scope.elementData.answers.find(answer => answer.score === score);
      newAnswers.push(existingAnswer ? existingAnswer : { score });
    }
    if ($scope.elementData.order === DESC_ORDER_ID) {
      newAnswers.reverse();
    }
    $scope.elementData.answers = newAnswers;
  }

  function initElementDataValueRange() {
    if ($scope.elementData.valueRange) {
      $scope.rangeTypes.forEach(range => {
        if (angular.equals($scope.elementData.valueRange, range)) {
          $scope.elementData.valueRange = range; // ng-model doesn't use deep equality
        }
      });
    } else {
      $scope.elementData.valueRange = $scope.rangeTypes[0];
    }
  }



  function init() {
    $scope.companyId = context.companyId;
    $scope.site = context.site;
    $scope.editorConfiguration = {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
    };
    $scope.editorModelAccessor = {};

    $scope.elementData = elementData;
    $scope.siteTypeConfig = siteTypeConfig;
    $scope.answerLabelMaxLength = $scope.siteTypeConfig.openSectionsButtonInListMessages ? 24 : null;
    $scope.feedbackTypes = [NPS_TYPE, CSAT_TYPE, CES_TYPE, NES_TYPE, CUSTOM_TYPE];
    $scope.rangeTypes = [VALUE_RANGE_0_1, VALUE_RANGE_0_10, VALUE_RANGE_1_10, VALUE_RANGE_1_9, VALUE_RANGE_1_7, VALUE_RANGE_1_5];
    $scope.sortTypes = [ASC_ORDER_TYPE, DESC_ORDER_TYPE];
    $scope.scoreTypes = [NPS_SCORE_TYPE, CSAT_SCORE_TYPE, CES_SCORE_TYPE];

    $scope.customValuesDisabled = elementData.feedbackType !== 'custom';
    initElementDataValueRange();
    valueRangeChanged();
  }

}

function newMeasurementParams(name, valueRange, orderId, scoreId, negativeFrom, negativeTo, positiveFrom, positiveTo) {
  const params = {
    'name': name,
    'valueRange': valueRange,
    'order': orderId,
    'score': scoreId
  }
  if (typeof negativeFrom === 'number') {
    params.negativeAndPositiveRanges = {
      'negative': {
        'from': negativeFrom,
        'to': negativeTo
      },
      'positive': {
        'from': positiveFrom,
        'to': positiveTo
      },
    }
  }
  return params;
}


function rangeInclusive(a, b) {
  const result = [];
  for (let i = a; i <= b; i++) {
    result.push(i);
  }
  return result;
}
